/* eslint-disable import/prefer-default-export */
import axios from 'axios'

export const identifySegmentUser = body =>
  axios
    .post(`${process.env.GATSBY_IDENTITY_SERVICE_URL}/user`, {
      ...body,
    })
    .then(response => response.data)

export const getSegmentIdByEmail = body =>
  axios
    .get(`${process.env.GATSBY_EMAIL_SERVICE_URL}/userId`, {
      params: { ...body },
    })
    .then(response => response.data)

export const getPersonalizedSegmentData = userId =>
  axios.get(`${process.env.GATSBY_PERSONALIZE_SERVICE_URL}/v2/purchaseJourney?fingerprintId=${userId}`)
